"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MY_SETTINGS = void 0;
var MY_SETTINGS = {
  INPUT_NAME: 'mySettings-input-name',
  INPUT_EMAIL: 'mySettings-input-email',
  INPUT__NEW_EMAIL: 'mySettings-input-newEmail',
  INPUT__CONFIRM_PASS: 'mySettings-input-confirmPass'
};
exports.MY_SETTINGS = MY_SETTINGS;